import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import columns from 'UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import { ITableColumnsType } from 'uikit/tables/default'

export const dataScienceColumns: ITableColumnsType<any> = [
  { ...columns[COLUMNS_IDS.verifiedName], title: 'Site Name', fixed: 'left' },
  columns[COLUMNS_IDS.entityDetailsSiteId],
  columns[COLUMNS_IDS.entityDetailsNaicsCdtfa],
  columns[COLUMNS_IDS.entityDetailsNaicsIvix],
  { ...columns[COLUMNS_IDS.dataSources], title: 'Web Sources' },
  columns[COLUMNS_IDS.aggregatedTotalsFirstActivity],
  columns[COLUMNS_IDS.accountName],
  columns[COLUMNS_IDS.customerName],
  columns[COLUMNS_IDS.accountId],
  columns[COLUMNS_IDS.qtrYieldIvix],
  columns[COLUMNS_IDS.salesTaxesDue],
  columns[COLUMNS_IDS.businessType],
  columns[COLUMNS_IDS.siteStartDate],
  columns[COLUMNS_IDS.siteEndDate],
  columns[COLUMNS_IDS.numYearsWithQtrYield],
  columns[COLUMNS_IDS.totalAdjustedOfTotalDue],
  { ...columns[COLUMNS_IDS.locations], title: 'Address' },
  columns[COLUMNS_IDS.siteStatus],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  dataScienceColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
